import { styled } from '@linaria/react';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px 16px;
  gap: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`;

export const LoaderWrapper = styled.div`
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: var(--tg-theme-text-color, #ffffff);
  margin: 0;
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--tg-theme-hint-color, rgba(255, 255, 255, 0.6));
  margin: 0;
  max-width: 320px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: 16px;

  button {
    width: 100%;
  }
`;
